import type { ViewStyle } from 'react-native';

import { Flex } from '../../../../../../../../mads';
import { ViewJobDivider } from '../../../../Divider';

import React from 'react';

export type VJNegativeSpacingProps = {
    hasDivider: boolean;
    sx?: ViewStyle;
};

export const VJNegativeSpacing: React.FC<
    VJNegativeSpacingProps & {
        children?: React.ReactNode;
    }
> = ({ hasDivider, sx, children }) => {
    return (
        <>
            <Flex sx={sx}>{children}</Flex>
            {hasDivider && <ViewJobDivider />}
        </>
    );
};
